import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { DynPopup } from "../../../Components/DynPopup";
import { WidgetLists } from "../Widgets/WidgetLists";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { RadioButtonComponent } from "../../../Components/RadioButtonComponent";
import { CheckboxCompoment } from "../../../Components/CheckboxComponent";

export type PopupListsComponentProps = {
    widget: WidgetLists;
}

export class PopupListsComponent extends JSXComponent {
    props: PopupListsComponentProps;
    title: LanguageStringComponent;
    art: RadioButtonComponent;

    constructor(props: PopupListsComponentProps) {
        super(props);
    }

    onSave = (): boolean => {
        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;
        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement =
        <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetLists}>
            {this.renderTitle()}
            <div style={{ height: "10rem" }}>
                {this.renderArt()}
                {this.renderExcludeAdministrative()}
            </div>
        </DynPopup>

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        }); 
        return this.title.render();
    }

    onValueSelected = (event: Event) => {
        this.props.widget.props.art = parseInt((event.target as HTMLInputElement).value);
    }

    onExcludeAdministrative = (event: Event) => {
        let input: HTMLInputElement = (event.target) as HTMLInputElement;
        this.props.widget.props.excludeAdministrative = input.checked;
    }

    renderArt(): HTMLElement {
        return <RadioButtonComponent
            model={this.props.widget.props}
        field="art"
            options={[
                { description: `${Resources.Common.all}`, value: 2 },
                { description: `${Resources.Common.publicView}`, value: 0 },
                { description: `${Resources.Common.privateView}`, value: 1 }
            ]}
            inline={false}
            name={Resources.Common.labelType}
        changeEvent={this.onValueSelected} />
    }

    renderExcludeAdministrative(): HTMLElement {
        return <CheckboxCompoment
            model={this.props.widget.props}
            field={"excludeAdministrative"}
            label={Resources.Common.excludeAdministrative}
            createFormGroup={false}
            changeEvent={this.onExcludeAdministrative}
        />
    }

    render(): HTMLElement {
        return this.element;
    }
}
